import React from 'react';

import { gql } from '@apollo/client';
import { assertIsoDateTimeRange } from '@modernloop/shared/datetime';

import { ActivityLogInterviewerRsvpTentative_ActivityLogFragment, ResponseStatus } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import ActivityLogContent from 'src/entities/ActivityLog/Helpers/ActivityLogContent';

import { ProposedTimeContent } from '../shared/InterviewerRsvp/ProposedTimeContent';

interface Fragments {
  activityLog: ActivityLogInterviewerRsvpTentative_ActivityLogFragment;
}

const ActivityLogTaskInterviewerRsvpTentative: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;
  // eslint-disable-next-line no-underscore-dangle
  if (!details || details.__typename !== 'ActivityLogInterviewerRsvpTentativeDetails') {
    throw new Error(
      'ActivityLogInterviewerRsvpTentativeDetails: details is not ActivityLogInterviewerRsvpTentativeDetails'
    );
  }
  const { interviewName, comment, proposedTime } = details;

  return (
    <ActivityLogBase
      activityLog={activityLog}
      responseStatus={ResponseStatus.Tentative}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.respondedMaybeForInterview"
      actionLabelValues={{ interviewName }}
    >
      {comment ? <ActivityLogContent content={comment} /> : null}
      {proposedTime ? <ProposedTimeContent proposedTime={assertIsoDateTimeRange(proposedTime)} /> : null}
    </ActivityLogBase>
  );
};

ActivityLogTaskInterviewerRsvpTentative.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogInterviewerRsvpTentative_activityLog on ActivityLog {
      id
      details {
        __typename
        ... on ActivityLogInterviewerRsvpTentativeDetails {
          __typename
          interviewName
          comment
          proposedTime {
            startAt
            endAt
          }
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskInterviewerRsvpTentative;
